import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class ChannelLinkSerializer extends ApplicationSerializer {
  attrs = {
    status: { serialize: false },
  };
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'channel-link': ChannelLinkSerializer;
  }
}
